import { configureStore } from '@reduxjs/toolkit';
import { miniBookingWidgetSlice } from './../features/MiniBookingWidget/MiniBookingWidgetSlice';
import { bookingWidgetReviewsSlice } from './../features/ReviewsSlice';
import { bookingWidgetRoomsSlice } from 'features/roomsSlice';
import { bookingWidgetMultipropertySlice } from 'features/multiproperty/MultipropertySlice';
import { modalSlice } from './../features/modalSlice';
import { drawersSlice } from './../features/drawersSlice';
import { userSlice } from 'features/userSlice';
import { noAvailablePricesSlice } from 'features/noAvailablePrices/NoAvailablePricesSlice';
import { bookingWidgetRoomFormSlice } from 'features/roomBookingFormSlice';
import { cartSlice } from 'features/cart/cartSlice';

export default configureStore({
    reducer: {
        miniBookingWidget: miniBookingWidgetSlice.reducer,
        reviews: bookingWidgetReviewsSlice.reducer,
        rooms: bookingWidgetRoomsSlice.reducer,
        multiproperty: bookingWidgetMultipropertySlice.reducer,
        cart: cartSlice.reducer,
        modal: modalSlice.reducer,
        drawers: drawersSlice.reducer,
        user: userSlice.reducer,
        noAvailablePrices: noAvailablePricesSlice.reducer,
        roomForm: bookingWidgetRoomFormSlice.reducer,
    },
});
